import { NgModule } from '@angular/core';
import { DropdownSelect2Component } from './dropdown-select2.component';
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@NgModule({
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule
  ],
  declarations: [DropdownSelect2Component],
  exports: [DropdownSelect2Component]
})
export class DropdownSelect2Module { }
